import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import LandingPage from './LandingPage';
import HungerScaleEntry from './HungerScaleEntry';
import SettingsPage from './SettingsPage';
import UserStatsPage from './UserStatsPage';
import WeightEntryPage from './WeightEntryPage';
import DailyActivityPage from './DailyActivityPage';
import CoachPage from './CoachPage';

const AppLandingRouter: React.FC<{ onLogout: () => void }> = ({ onLogout }) => {
  const [page, setPage] = useState<'main' | 'meal' | 'coach' | 'settings' | 'userStats' | 'weightEntry' | 'dailyActivity'>('main');

  const pageVariants = {
    initial: { opacity: 0, x: -50 },
    enter: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 50 }
  };

  return (
    <AnimatePresence mode="wait">
      {page === 'main' && (
        <motion.div
          key="main"
          initial="initial"
          animate="enter"
          exit="exit"
          variants={pageVariants}
          transition={{ duration: 0.3 }}
        >
          <LandingPage onSelect={val => setPage(val)} />
        </motion.div>
      )}
      {page === 'meal' && (
        <motion.div
          key="meal"
          initial="initial"
          animate="enter"
          exit="exit"
          variants={pageVariants}
          transition={{ duration: 0.3 }}
        >
          <HungerScaleEntry onBack={() => setPage('main')} />
        </motion.div>
      )}
      {page === 'settings' && (
        <motion.div
          key="settings"
          initial="initial"
          animate="enter"
          exit="exit"
          variants={pageVariants}
          transition={{ duration: 0.3 }}
        >
          <SettingsPage onLogout={onLogout} onBack={() => setPage('main')} />
        </motion.div>
      )}
      {page === 'coach' && (
        <motion.div
          key="coach"
          initial="initial"
          animate="enter"
          exit="exit"
          variants={pageVariants}
          transition={{ duration: 0.3 }}
        >
          <CoachPage onBack={() => setPage('main')} />
        </motion.div>
      )}
      {page === 'userStats' && (
        <motion.div
          key="userStats"
          initial="initial"
          animate="enter"
          exit="exit"
          variants={pageVariants}
          transition={{ duration: 0.3 }}
        >
          <UserStatsPage onBack={() => setPage('main')} />
        </motion.div>
      )}
      {page === 'weightEntry' && (
        <motion.div
          key="weightEntry"
          initial="initial"
          animate="enter"
          exit="exit"
          variants={pageVariants}
          transition={{ duration: 0.3 }}
        >
          <WeightEntryPage onBack={() => setPage('main')} />
        </motion.div>
      )}
      {page === 'dailyActivity' && (
        <motion.div
          key="dailyActivity"
          initial="initial"
          animate="enter"
          exit="exit"
          variants={pageVariants}
          transition={{ duration: 0.3 }}
        >
          <DailyActivityPage onBack={() => setPage('main')} />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AppLandingRouter;
